import { GridFilterInputBoolean, sanitizeFilterItemValue } from "../components/panel/filterPanel/GridFilterInputBoolean.js";
export var getGridBooleanOperators = function() {
    return [
        {
            value: 'is',
            getApplyFilterFn: function(filterItem) {
                var sanitizedValue = sanitizeFilterItemValue(filterItem.value);
                if (sanitizedValue === undefined) {
                    return null;
                }
                return function(value) {
                    return Boolean(value) === sanitizedValue;
                };
            },
            InputComponent: GridFilterInputBoolean
        }
    ];
};
